<template>
  <spinner :message="message" :show="isLoading" />
</template>

<script>
import Spinner from "@/components/util/Spinner.vue";
import Trimaster from "@/plugins/servers/trimaster.js";
import vuetifyToast from "@/vuetifyToast.js";
import { mapGetters } from "vuex";
import moment from "moment-timezone";

let lexConfig = {
  silenceDetection: true,
  silenceDetectionConfig: {
    time: 1500,
    amplitude: 0.2
  },
  lexConfig: {
    botAlias: "$LATEST",
    contentType: "audio/x-l16; sample-rate=16000",
    accept: "audio/mpeg",
    botName: "TrimasterBot",
    userId: "us-east-1:Af907d355-51f0-4009-959a-e85d431fbfb9"
  }
};

export default {
  name: "lex-bot",
  components: {
    Spinner
  },
  props: {
    adjustUserId: {
      type: [Number, String],
      default: 1
    },
    start: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      isRecording: false,
      message: "",
      conversation: null
    };
  },
  watch: {
    start(val) {
      if (!val) {
        return this.$emit("stopped", val);
      }

      return this.startConversation();
    }
  },
  computed: {
    ...mapGetters(["getUser"])
  },
  methods: {
    saveQuestion(question, answer) {
      const vm = this;

      Trimaster.post(`lex_questions`, vm.getUser.apitoken, {
        user_id: vm.getUser.id * +vm.adjustUserId,
        question: question,
        answer: answer
      }).then(([res, err]) => {
        if (err) return vuetifyToast.error(err);

        vm.$emit("finished");
        vm.$root.eventHub.$emit("lex-bot-saved-question", {
          question,
          answer,
          server_response: res
        });
        vm.isLoading = false;
        vm.isRecording = false;
      });
    },
    startConversation() {
      const vm = this;

      if (vm.isRecording) {
        vm.conversation.reset();
        vm.isRecording = false;
        return;
      }

      vm.message = "Please speak your question or say 'stop' to cancel.";
      let conversation = new LexAudio.conversation(
        lexConfig,
        state => {
          switch (state) {
            case "Listening":
              vm.isLoading = true;
              break;
            case "Sending":
              vm.message = "Sending your question to the cloud...";
              vm.isLoading = true;
              break;
            case "Speaking":
              break;
            case "Passive":
              vm.message = "Bot has finished your request.";
              vm.isRecording = false;
              vm.isLoading = false;
              break;
          }
        },
        data => {
          let finished = true;
          data.slots = data.slots || [];
          vm.message = data.message;

          // if (data.slots) {
          //     let slotKeys = Object.keys(data.slots)
          //     if (slotKeys.length) {
          //         finished = false
          //         var count = 0;

          //         slotKeys.forEach(slot_key => {
          //             if (data.slots[slot_key] != null) count++;
          //         })
          //         if (slotKeys.length === count) finished = true
          //     }
          // }

          // // The questioning is not complete
          // if (!finished) {
          //     return
          // }

          let endpoint = data.intentName;
          vm.isRecording = false;
          vm.isLoading = false;

          // If a bad request then just show the message from the lex bot
          if (!endpoint || !endpoint.length) {
            return vm.saveQuestion(data.inputTranscript, data.message);
          }

          vm.$emit("stopped");

          data.slots.facility_id = vm.getUser.facility_id;
          data.slots.user_timezone = moment.tz.guess();

          switch (endpoint) {
            case "scheduleCalendarEvent":
              // Convert to UTC
              let fromDate = moment
                .tz(
                  `${data.slots.fromdate} ${data.slots.fromtime}`,
                  data.slots.user_timezone
                )
                .utc();
              let toDate = moment
                .tz(
                  `${data.slots.todate} ${data.slots.totime}`,
                  data.slots.user_timezone
                )
                .utc();

              data.slots.fromdate = fromDate.format("YYYY-MM-DD");
              data.slots.fromtime = fromDate.format("HH:mm");
              if (toDate.isValid()) {
                data.slots.todate = toDate.format("YYYY-MM-DD");
                data.slots.totime = toDate.format("HH:mm");
              }
              break;
            case "setVfuControlState":
              data.slots.facility_id = vm.getUser.facility_id;
              break;
          }

          // do stuff based on parsed conversation
          if (endpoint != "Stop") {
            return Trimaster.post(`lexbots/${endpoint}`, vm.getUser.apitoken, {
              facility_id : vm.getUser.facility_id,
              params: data.slots
            }).then(([res2, err2]) => {
              if (err2) return vm.saveQuestion(data.inputTranscript, err2);

              switch (endpoint) {
                case "scheduleCalendarEvent":
                  setTimeout(() => {
                    vm.$root.eventHub.$emit("refresh-calendar");
                  }, 200);
                  break;
              }

              return vm.saveQuestion(data.inputTranscript, res2);
            });
          } else {
            this.$emit('recording',false);
          }
        },
        err => {
          vuetifyToast.error(err);
          vm.isRecording = false;
          vm.isLoading = false;
        },
        timeDomain => {}
      );
      this.conversation = conversation;
      conversation.advanceConversation();
      vm.isRecording = true;
    }
  }
};
</script>
